// PDF.js integration utilities
import * as pdfjsLib from '../assets/pdf.mjs';

// Configure PDF.js worker using URL constructor for proper asset resolution
const workerUrl = new URL('../assets/pdf.worker.mjs', import.meta.url);
pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl.href;

export interface PDFDocument {
  numPages: number;
  getPage: (pageNumber: number) => Promise<PDFPage>;
  keepPages: (pageNumbers: number[]) => Promise<void>;
  saveDocument: () => Promise<Uint8Array>;
}

export interface PDFPage {
  getViewport: (options: { scale: number }) => PDFViewport;
  render: (options: RenderOptions) => RenderTask;
}

export interface PDFViewport {
  width: number;
  height: number;
  transform: number[];
}

export interface RenderOptions {
  canvasContext: CanvasRenderingContext2D;
  viewport: PDFViewport;
}

export interface RenderTask {
  promise: Promise<void>;
  cancel: () => void;
}

export async function loadPDF(file: File): Promise<PDFDocument> {
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
  
  return pdf;
}
